import { styled } from '@mui/material/styles';
import { Box, Typography, Tabs, Tab } from '@mui/material';

// ============================================
// Container & Layout
// ============================================
export const PageContainer = styled(Box)({
  background: 'transparent',
  borderRadius: '0',
  padding: '0',
  boxShadow: 'none !important',
});

export const HeaderRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '20px',
});

export const BackLink = styled('div')({
  textDecoration: 'none',
  color: '#525252',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  transition: 'color 0.15s',
  '&:hover': { color: '#262626' },
});

export const HeaderTitle = styled(Typography)({
  fontSize: '20px',
  fontWeight: 700,
  color: '#262626',
});

export const ListLink = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '8px 20px',
  borderRadius: '10px',
  backgroundColor: '#f5f5f5',
  color: '#525252',
  fontSize: '14px',
  fontWeight: 600,
  transition: 'all 0.15s',
  '&:hover': { backgroundColor: '#e5e5e5', color: '#262626' },
});

export const Divider = styled('hr')({
  display: 'none',
});

export const TabDivider = styled('hr')({
  display: 'none',
});

// ============================================
// Employee Name Section
// ============================================
export const NameSection = styled(Box)({
  display: 'none',
});

export const EmployeeName = styled(Typography)({
  display: 'none',
});

// ============================================
// Tabs Section
// ============================================
export const TabsContainer = styled(Box)({
  marginBottom: '24px',
});

export const StyledTabs = styled(Tabs)({
  minHeight: '40px',
  '& .MuiTabs-indicator': { display: 'none' },
  '& .MuiTabs-flexContainer': { gap: '8px' },
});

export const StyledTab = styled(Tab)({
  minHeight: '40px',
  padding: '8px 20px',
  borderRadius: '12px',
  border: '1px solid #e5e5e5',
  fontSize: '14px',
  fontWeight: 600,
  color: '#737373',
  textTransform: 'none',
  transition: 'all 0.15s',
  '&:hover': {
    backgroundColor: '#f5f5f5',
    borderColor: '#d4d4d4',
  },
  '&.Mui-selected': {
    background: 'linear-gradient(135deg, #4ab3bc 0%, #3a9da5 100%)',
    border: 'none',
    color: '#fff',
    boxShadow: '0 2px 8px rgba(74,179,188,0.3)',
  },
});
